import { call, put, takeLatest } from 'redux-saga/effects';

import * as requestActions from './requestActions.js';
import { updateRequestApiCall } from './requestAPI.js';

function* updateRequestSaga({ payload }) {
  try {
    const { data } = yield call(updateRequestApiCall, payload);
    yield put(requestActions.requestUpdateStore(data));
  } catch (error) {
    yield put(requestActions.requestUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* requestWatcher() {
  yield takeLatest(requestActions.requestUpdateRequest.type, updateRequestSaga);
}
